module.exports = __webpack_public_path__ + "majorLogo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/majorLogo.png
// module id = 1873
// module chunks = 0